<template>
  <div class="detail-container">
    <item-tip />
    <menu-article
      :id="id"
      :article="detail"
      :show-logo="ShowLogo"
      :title="title"
    />
  </div>
</template>
<script>
  import { getMenuArticle } from '@/api/site'
  import { SetLogoPathNames, DealContent } from '@/utils/index'
  export default {
    name: 'Electact',
    data() {
      return {
        id: 'KO',
        title: '推选活动',
        isMultImage: false,
        ShowLogo: false,
        showDetails: true,
        detail: {
          content: '',
          list: [],
          ArticleID: '',
          title: '',
          abstract: '',
        },
      }
    },
    async created() {
      await this.getDetail()
    },
    methods: {
      async getDetail() {
        if (this.id) {
          let param = { SID: this.id }
          var res = await getMenuArticle(param)
          if (res.data) {
            let data = res.data
            this.detail.ArticleID = data.ArticleID
            this.detail.title = data.Title || ''
            this.detail.abstract = data.Abstract || ''
            if (data.Contents) {
              this.detail.content = DealContent(data.Contents)
            }
            if (data.LogoPath && data.OssImagePath) {
              this.detail.list = SetLogoPathNames(data)
            }
          }
        }
      },
    },
  }
</script>
